export const UserCan = {
  install(Vue2, {store, abilities}) {
    Vue2.directive('can', {
      bind(el, binding, vnode) {
        let ok = false

        // We can either hide the element (which is the default behavior) or we can
        // disable it, in the case of a button or input.
        // v-can.disable="'perm1'"
        const behaviour = binding.modifiers.disable ? 'disable' : 'hide'

        // Allows the passing of an array to the v-can directive and defines whether any or all pass:
        // v-can:all="['perm1', 'perm2', 'perm3']"
        // It will default to passing if any permissions match:
        // v-can="['perm1', 'perm2', 'perm3']"
        const mode = binding.arg === 'all' ? 'all' : 'any'

        if (binding.value.constructor === Array) {
          if(mode === 'all') {
            ok = _.intersection(abilities, binding.value).length === binding.value.length
          } else {
            ok = _.intersection(abilities, binding.value).length > 0
          }
        } else {
          ok = abilities.indexOf(binding.value) > -1
        }

        if (!ok) {
          if (behaviour === 'hide') {
            el.style.display = 'none'
          } else if (behaviour === 'disable') {
            el.disabled = true
          }
        }
      },
    })
  },
}

export const UserCannot = {
  install(Vue2, {store, abilities}) {
    Vue2.directive('cannot', {
      bind(el, binding, vnode) {
        let ok = false

        const behaviour = binding.modifiers.disable ? 'disable' : 'hide'

        const mode = binding.arg === 'all' ? 'all' : 'any'

        if(binding.value.constructor === Array) {
          if(mode === 'all') {
            ok = _.intersection(abilities, binding.value).length === binding.value.length
          } else {
            ok = _.intersection(abilities, binding.value).length > 0
          }
        } else {
          ok = abilities.indexOf(binding.value) > -1
        }

        if(ok) {
          if(behaviour === 'hide') {
            el.style.display = 'none'
          } else if (behaviour === 'disable') {
            el.disabled = true
          }
        }
      },
    })
  },
}